import { Link } from "@tanstack/react-router";
import background from "~/assets/404-map.svg";
import { withLocale } from "~/lib/utils/with-locale";
import { Button } from "./ui/button";

export function NotFound({ children }: { children?: any }) {
  return (
    <div className="bg-[#0a0a0a] relative layout-place-full-width layout-content-grid min-h-[calc(100vh-72px)] text-white">
      <div className="absolute inset-0">
        <img src={background} alt="404" className="w-full h-auto object-cover" />
      </div>
      <div className="relative z-10 px-4 md:pl-[120px] pt-8 md:pt-12 pb-8">
        <h1 className="text-6xl md:text-[170px] leading-none">404</h1>
        <p className="uppercase text-2xl md:text-5xl font-medium mt-4 md:mt-0">
          Hoppla!
          <br />
          Falscher Ort.
        </p>
        <p className="text-base md:text-xl font-light mt-4 md:mt-6">
          Diese Seite gibt's nicht – aber wir haben
          <br />
          viele andere Highlights für dich.
        </p>
        <p className="mt-8 md:mt-12">
          <Button asChild size={"lg"}>
            <Link to={withLocale("/")}>Jetzt entdecken</Link>
          </Button>
        </p>
      </div>
    </div>
  );
}
